import {
  handleAddLevel,
  handleDeleteLevel,
  handleEditLevel,
  handleRestoreLevel,
} from 'serviceWorker/services/levels';
import { levelSource } from 'serviceWorker/services/levels/levelSource';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { levelContract } from 'shared/domain/level/levelContract';
import { serveEntityRequests } from './serveEntityRequests';

/**
 * Answers the level requests: one level for the views that show it, and
 * changes, answered once queued (the outcome follows as an event with their `uniqueId`).
 */
export function serveLevelRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(levelContract, levelSource),
    channelServer.handle(levelContract, {
      getOneById: ({ id }) => levelSource.getOneById(id),
      create: handleAddLevel,
      edit: handleEditLevel,
      remove: handleDeleteLevel,
      restore: handleRestoreLevel,
    }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
